export async function svgmoverinit() {
    if (location.pathname == "/") {
        let svg = document.querySelector(".bg")
        let mouse = {
            x: 0,
            y: 0
        }
        window.onmousemove = (e) => {
            mouse.x = (e.clientX / window.innerWidth - 0.5) * 1.5
            mouse.y = (e.clientY / window.innerHeight - 0.5) * 1.5 * (window.innerWidth / window.innerHeight)
            svg.style.transform = `translate(${mouse.x}%,${mouse.y}%) scale(1.1)`
        }
    } else {
        window.onmousemove = null
    }
}